import { IConstructionProgressSchema } from '../../repositories/construction-progress/entities/get_construction_progress_page/ConstructionProgressSchema';
import { IConstructionProgressStage } from '../../types/constructionProgress';
import { prepareImage } from './prepareImage';

export const prepareConstructionProgress = (
  data: IConstructionProgressSchema,
  newbuildingName: string,
): IConstructionProgressStage => {
  return {
    date: data.date,
    images: data.images.map(img => prepareImage(img, newbuildingName, data.date)),
  };
};
